"use client"

import { useState } from "react"

const AirTicketForm = ({ onSubmit, onCancel }) => {
  const [formData, setFormData] = useState({
    item_name: "",
    description: "",
    quantity: 1,
    cost_price: 0,
    selling_price: 0,
    margin: 0,
    total_amount: 0,
    item_type: "air_ticket",
    // Air ticket specific fields
    airline: "",
    flight_number: "",
    departure_city: "",
    arrival_city: "",
    departure_date: "",
    return_date: "",
    passenger_name: "",
    ticket_class: "economy",
    baggage_allowance: "",
    meal_preference: "",
  })

  const handleInputChange = (e) => {
    const { name, value } = e.target
    setFormData((prev) => {
      const updated = { ...prev, [name]: value }

      const costPrice = Number(updated.cost_price) || 0
      const sellingPrice = Number(updated.selling_price) || 0
      const quantity = Number(updated.quantity) || 1

      // Auto margin %
      if (costPrice > 0) {
        updated.margin = Math.round(((sellingPrice - costPrice) / costPrice) * 100)
      } else {
        updated.margin = 0
      }

      // Auto total
      updated.total_amount = sellingPrice * quantity

      return updated
    })
  }

  const handleSubmit = (e) => {
    e.preventDefault()

    // Extra validation for dates
    if (!formData.departure_date) {
      alert("Please select a departure date")
      return
    }

    // (Optional) if return date is mandatory, uncomment below:
    // if (!formData.return_date) {
    //   alert("Please select a return date")
    //   return
    // }

    onSubmit(formData)
  }

  return (
    <form onSubmit={handleSubmit} className="item-form">
      <div className="form-grid">
        <div className="form-group">
          <label>Item Name *</label>
          <input
            type="text"
            name="item_name"
            value={formData.item_name}
            onChange={handleInputChange}
            placeholder="e.g., Dubai to London Flight"
            required
          />
        </div>

        <div className="form-group">
          <label>Airline *</label>
          <input
            type="text"
            name="airline"
            value={formData.airline}
            onChange={handleInputChange}
            placeholder="e.g., Emirates, Qatar Airways"
            required
          />
        </div>

        <div className="form-group">
          <label>Flight Number</label>
          <input
            type="text"
            name="flight_number"
            value={formData.flight_number}
            onChange={handleInputChange}
            placeholder="e.g., EK123"
          />
        </div>

        <div className="form-group">
          <label>Passenger Name *</label>
          <input
            type="text"
            name="passenger_name"
            value={formData.passenger_name}
            onChange={handleInputChange}
            placeholder="Full name as per passport"
            required
          />
        </div>

        <div className="form-group">
          <label>From City *</label>
          <input
            type="text"
            name="departure_city"
            value={formData.departure_city}
            onChange={handleInputChange}
            placeholder="e.g., Dubai"
            required
          />
        </div>

        <div className="form-group">
          <label>To City *</label>
          <input
            type="text"
            name="arrival_city"
            value={formData.arrival_city}
            onChange={handleInputChange}
            placeholder="e.g., London"
            required
          />
        </div>

        <div className="form-group">
          <label>Departure Date *</label>
          <input
            type="date"
            name="departure_date"
            value={formData.departure_date}
            onChange={handleInputChange}
            required
          />
        </div>

        <div className="form-group">
          <label>Return Date</label>
          <input
            type="date"
            name="return_date"
            value={formData.return_date}
            onChange={handleInputChange}
          />
        </div>

        <div className="form-group">
          <label>Class *</label>
          <select name="ticket_class" value={formData.ticket_class} onChange={handleInputChange} required>
            <option value="economy">Economy</option>
            <option value="premium_economy">Premium Economy</option>
            <option value="business">Business</option>
            <option value="first">First Class</option>
          </select>
        </div>

        <div className="form-group">
          <label>Quantity *</label>
          <input
            type="number"
            name="quantity"
            value={formData.quantity}
            onChange={handleInputChange}
            min="1"
            required
          />
        </div>

        <div className="form-group">
          <label>Cost Price *</label>
          <input
            type="number"
            name="cost_price"
            value={formData.cost_price}
            onChange={handleInputChange}
            step="0.01"
            min="0"
            required
          />
        </div>

        <div className="form-group">
          <label>Selling Price *</label>
          <input
            type="number"
            name="selling_price"
            value={formData.selling_price}
            onChange={handleInputChange}
            step="0.01"
            min="0"
            required
          />
        </div>

        <div className="form-group">
          <label>Baggage Allowance</label>
          <input
            type="text"
            name="baggage_allowance"
            value={formData.baggage_allowance}
            onChange={handleInputChange}
            placeholder="e.g., 23kg"
          />
        </div>

        <div className="form-group">
          <label>Meal Preference</label>
          <select name="meal_preference" value={formData.meal_preference} onChange={handleInputChange}>
            <option value="">No Preference</option>
            <option value="vegetarian">Vegetarian</option>
            <option value="vegan">Vegan</option>
            <option value="halal">Halal</option>
            <option value="kosher">Kosher</option>
            <option value="gluten_free">Gluten Free</option>
          </select>
        </div>
      </div>

      <div className="form-group full-width">
        <label>Description</label>
        <textarea
          name="description"
          value={formData.description}
          onChange={handleInputChange}
          placeholder="Additional details about the flight booking..."
          rows="3"
        />
      </div>

      <div className="pricing-summary">
        <div className="summary-item">
          <span>Margin: {formData.margin}%</span>
        </div>
        <div className="summary-item">
          <span>Total Amount: ${(formData.total_amount || 0).toFixed(2)}</span>
        </div>
      </div>

      <div className="form-actions">
        <button type="button" className="btn-secondary" onClick={onCancel}>
          Cancel
        </button>
        <button type="submit" className="btn-primary">
          Add Air Ticket
        </button>
      </div>
    </form>
  )
}

export default AirTicketForm
